import set from "@rill/set";
import _ from "lodash";
import moment from "moment";
import ActivityDrawer from "../../../parts/activity-drawer/ActivityDrawer";
import RpeTable from "./RpeTable";
import { isAdminOrOwner } from "../../../utils/organization-permissions-helpers";

const RpeReport = (app) => {
  app.get(
    "/rpe-report",
    set("heading", "RPE Table"),
    async ({ req, res, load, locals }) => {
      const { query = {} } = req;
      const { from, to, primary, type, secondary } = query;

      const athleteId = locals.athlete
        ? locals.athlete._id
        : locals.activeUser._id;

      const isAllowToViewAllOrganizationsAthletes = isAdminOrOwner(
        locals.organizationRoleName
      );

      if (
        locals.activeUser.organizationId &&
        isAllowToViewAllOrganizationsAthletes &&
        !locals.allAthletesFromOrganization
      ) {
        await load("allAthletesFromOrganization");
      }

      await load("exerciseHistory", {
        primary: primary || "squat",
        type: type || "primary",
        secondary: secondary || "",
        proxyAthlete: athleteId,
        from: from
          ? moment.utc(from).toDate()
          : moment.utc(moment().subtract(6, "months")).toDate(),
        to: to ? moment.utc(to).toDate() : moment.utc(moment()).toDate(),
      });
      const modal = _.get(query, "modal", {});
      locals.modal = {
        "activity-feed": <ActivityDrawer />,
      }[modal.type];
      res.body = <RpeTable locals={locals} />;
    }
  );
};

export default RpeReport;
